<template>
  <!--<transition name="fade">-->
  <div class="progress" v-if="show">
    <div class="loading">
      <fnd-lottie
        src="https://image.hanatour.com/usr/static/json/mobile/load/hnt_loading.json"
        :height="140"
        :width="140"
        :loop="true"
        :autoplay="true"
      />
      <p class="sort_tit comm">
        <em>하나하나가 새롭다</em>
      </p>
    </div>
  </div>
  <!--</transition>-->
</template>

<script>
import FndLottie from 'views/components/lottie'
export default {
  components: {
    FndLottie,
  },
  data() {
    return {
      percent: 0,
      show: true,
      canSuccess: true,
      duration: 3000,
    }
  },
  computed: {
    style() {
      return {
        // width: this.percent + '%',
        // height: this.height,
        // backgroundColor: this.canSuccess ? this.color : this.failedColor,
        // opacity: this.show ? 1 : 0
      }
    },
  },
  methods: {
    start() {
      this.show = true
      this.canSuccess = true
      if (this._timer) {
        clearInterval(this._timer)
        this.percent = 0
      }
      this._cut = 10000 / Math.floor(this.duration)
      this._timer = setInterval(() => {
        this.increase(this._cut * Math.random())
        if (this.percent > 95) {
          this.finish()
        }
      }, 100)
      return this
    },
    set(num) {
      this.show = true
      this.canSuccess = true
      this.percent = Math.floor(num)
      return this
    },
    get() {
      return Math.floor(this.percent)
    },
    increase(num) {
      this.percent = this.percent + Math.floor(num)
      return this
    },
    decrease(num) {
      this.percent = this.percent - Math.floor(num)
      return this
    },
    finish() {
      this.percent = 100
      this.hide()
      return this
    },
    pause() {
      clearInterval(this._timer)
      return this
    },
    hide() {
      clearInterval(this._timer)
      this._timer = null
      setTimeout(() => {
        this.$nextTick(() => {
          setTimeout(() => {
            this.show = false
            this.percent = 0
          }, 200)
        })
      }, 100)
      return this
    },
    fail() {
      this.canSuccess = false
      return this
    },
  },
}
</script>

<style scoped lang="scss" src="./style.scss" />
